import ReactGA from "react-ga";

const ENVIRONMENT_ID = {
  prod: "UA-164383136-5",
  stage: "UA-164383136-1",
  dev: "UA-164383136-1",
};

export const initializeAnalytics = environment => {
  const environmentID = ENVIRONMENT_ID[environment];
  ReactGA.initialize(environmentID, {
    debug: environmentID !== "prod",
    titleCase: false,
    send_page_view: false,
  });
};

export const generateAnalyticsEvent = ({
  category,
  action,
  label,
  value,
  nonInteraction,
  transport,
}) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
    nonInteraction,
    transport,
  });
};

export const setAnalyticsValue = object => {
  ReactGA.set(object);
};

export const setAnalyticsPageView = page => {
  ReactGA.pageview(page);
};

export const trackPage = (page, extraOptions = {}) => {
  setAnalyticsValue({
    page,
    ...extraOptions,
  });
  setAnalyticsPageView(page);
};

export const logWebSurveyOpened = page => {
  generateAnalyticsEvent({
    category: "Web Survey",
    action: "Visited",
    label: page,
  });
};
